namespace Areas.Building.BuildingImage {
    "use strict";

    var isUpdateCanceled: boolean = false;

    export function buildingImage(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.buildingImageId; },
            "<img class='thumbnail' alt='image' src='/Building/BuildingImage/GetImage/{placeholder}'/>");
    }

    export function edit(cellElement, cellInfo) {
        var div = document.createElement("div");
        cellElement.get(0).appendChild(div);
        $(div).dxButton({
            text: "",
            icon: "edit",
            type: "normal",
            onClick: showUploadDialog({ 
                buildingId: cellInfo.data.buildingId, 
                buildingImageId: cellInfo.data.buildingImageId, 
                allowMultipleUploads: false
            })
        });
    }

    const customAddButtonName = "customAddButton";
    
    export function addButton(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;
        const data = { buildingId: grid.option("buildingId"), buildingImageId: 0, allowMultipleUploads: true};
        
        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: customAddButtonName },
            text: "Add",
            hint: "Add new building image",
            type: "success",
            icon: "plus",
            onClick: showUploadDialog(data)
        }, "center");
    } 

    export function showUploadDialog(data: any) {
        return () => {
            const buildingImageDialog = 
                new Areas.Dialog.BuildingImageDialog(dialogClosing, data);
        }
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        location.href = location.href;
    }     
}